import { useState } from "react";
import { useEffect } from "react";

import "../../assets/Styles/Details.css";
import img1 from "../../assets/Images/Bitmap (1).png";
import { useLocation, useNavigate } from "react-router";
// import { approved, userdetails } from "../../services/Mainservice";
import Loader from "../../Loader/Loader";

const RequestDetails = () => {
  const [loading, setloading] = useState(false);
  const [data, setData] = useState({
    id: 4,
    name: "Skyline Group Ltd.",
    requestedAt: "2025-04-21",
    email: "john@example.com",
    type: "compatibility",
    paymentStatus: "paid",
    analysisStatus: "pending",
    phone_number: "7923481012",
  });
  const [reason, setreason] = useState();
  const Navigate = useNavigate();
  const location = useLocation();

  // const id = location.state?.id;

  // useEffect(() => {
  // if (id) {
  // getData(id);
  // }
  // }, []);

  // const getData = async (id) => {
  //   try {
  //     const response = await userdetails(id);
  //     setData(response.data.data);
  //     setblock(response.data.data.is_block);
  //   } catch (error) {
  //     setloading(false);
  //     if (error.code === 401) {
  //       localStorage.clear();
  //       Navigate("/");
  //     }
  //   }
  // };

  const handleaction = async (status, note) => {
    setloading(true);
    // try {
    //   const response = await approved(data.id, status, note);
    //   getData(id);
    // } catch (error) {
    //   console.log(error);
    // }
  };

  return (
    <>
      <h1 className="userdetails_heading">Request Details </h1>
      <div className="userdetails">
        <div className="userdetails_up">
          <div className="userprofile_up2">
            <div className="userprofile_up_imglist">
              <img
                // src={
                //    data.base_photo
                // }
                src={img1}
                alt="img"
              />
            </div>

            <h1 className="username">{data.name}</h1>
          </div>
        </div>
        <div className="userdetails_down">
          <p className="userdata">
            Phone Mumber: <span>{data.phone_number}</span>
          </p>
          <p className="userdata">
            Email: <span>{data.email}</span>
          </p>

          <p className="userdata">
            Request At: <span> {data.requestedAt}</span>
          </p>

          <p className="userdata">
            Type: <span>{data.type}</span>
          </p>
          <p className="userdata">
            Payment: <span>{data.paymentStatus}</span>
          </p>

          <p className="userdata">
            Status:{" "}
            <span>
              {data.analysisStatus === "paid" ? (
                <span className="complete_data">Complete</span>
              ) : (
                <span className="pending_data">Pending</span>
              )}
            </span>
          </p>
          {/* <h1>25 Reports</h1> */}
          {data.paymentStatus === "paid" &&
            data.analysisStatus === "pending" && (
              <>
                <div className="userblocks">
                  <textarea
                    placeholder="Your Analysis Report"
                    name="reason"
                    className="userdeactive_textarea"
                    onChange={(e) => setreason(e.target.name)}
                  ></textarea>
                  <br />
                  <button
                    className="userdeactive_button"
                    onClick={() => handleaction("1")}
                  >
                    Send Analysis
                  </button>
                </div>
              </>
            )}
        </div>
      </div>

      {loading && <Loader />}
    </>
  );
};
export default RequestDetails;
